<template>
    <div class="page-container">
        <div class="tabbox">
            <div class="tabs">
                <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">充值记录</div>
                <div class="tab-item" :class="{actived:currentTab == 2}" @click="changeTab(2)">消费记录</div>
            </div>
        </div>
        <div class="record-types" v-show="currentTab == 1">
            <!-- <div class="type-item" :class="{actived:filterType == 0}" @click="changeFilter(0)">全部</div> -->
            <!-- <div class="type-item" v-for="(item,index) in pageData.listTwo" :key="index" v-show="item != 1" :class="{actived:filterType == item}" @click="changeFilter(item)">{{filterList[item]}}</div> -->
            <!-- <div class="type-item" :class="{actived:filterType == 2}" @click="changeFilter(2)">补款</div>
            <div class="type-item" :class="{actived:filterType == 3}" @click="changeFilter(3)">津贴划转入账</div> -->
        </div>
        <!-- 记录列表 -->
        <div class="record-list" v-if="list.length > 0">
            <div class="record-item" v-for="(item,index) in list" :key="index" @click="jumpPage(item.type,item.id,item.orderId)">
                <div class="item-top">
                    <div class="item-count">{{currentTab == 1 ? '+' : '-'}}{{item.amount}}</div>
                    <div class="item-status waiting">已完成</div>
                </div>
                <div class="item-bottom">
                    <span>{{currentTab == 1 ? '充值' : '消费'}}</span>
                    <span>{{item.addTime}}</span>
                </div>
            </div>
            <div class="record-item no-more">没有更多了</div>
        </div>
        <!-- 无记录 -->
        <van-empty v-else :image=nullImg description="暂无数据~" />
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import { Toast,Empty } from 'vant'

export default {
    data(){
        return {
            currentTab:1,//1 充值，2 消费
            filterType:0,//0 所有
            page:1,
            limit:50,
            filterList:{
                "1":"成为高级合伙人",
                "2":"补款",
                "3":"津贴划转入账",
                "4":"津贴提现",
                "5":"进货",
                "6":"推荐成为高级合伙人",
                "7":"推荐成为合伙人",
                "8":"被推荐人补款",
                "9":"兑换",
                "10":"成为合伙人"
            },
            pageData:{},
            list:[],
            nullImg:require('@/assets/icon-null.png'),
            customermobile:null,
            customerid:null,
        }
    },
    components:{
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    activated(){
        this.customermobile = window.localStorage.getItem('customermobile');
        this.customerid = window.localStorage.getItem('customerid');
        if(!this.customermobile) this.$router.go(-1);
        this.getData();
    },
    methods:{
        changeTab(tab){
            this.currentTab=tab;
            this.filterType=0;
            this.list=[];
            this.getData();
        },
        changeFilter(type){
            this.filterType=type;
            this.list=[];
            this.getData();
        },
        getData(){
            $http({
                method:'post',
                data:{
                    amountType:this.currentTab,
                    accountId:this.customerid,
                    mobile:this.customermobile
                },
                url:config.api.subpageDetail
            }).then(res=>{
                this.list=res;
            })
        },
        jumpPage(type,orderId,oid){
            if(this.currentTab == 1){
                if(type == 2){ //补款
                    this.$router.push({
                        name:'replenishment-detail',
                        params:{
                            orderId:orderId
                        }
                    });
                }
            }else{
                this.$router.push({
                    name:'purchase-detail',
                    params:{
                        orderId:oid
                    }
                });
            }
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.page-container{
    padding: 0 10px;
    background:#f5f5f5;
    min-height: 100vh;
    padding-top: 65px;
    box-sizing: border-box;
    .tabbox{
        position: fixed;
        background: #fff;
        top:0;
        left:0;
        width:100vw;
        height:65px;
        box-sizing: border-box;
        padding: 12px 38px;
        .tabs{
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            .tab-item{
                width:50%;
                height:40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                color:#2172F6;
                box-sizing: border-box;
                border:1px solid #3088F5;
                &.actived{
                    color:#fff;
                    background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
                    border:none;
                }
                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    border-right: none;
                }
                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-left: none;
                }
            }
        }
    }
    .record-types{
        padding-top:10px;
        // height:56px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .type-item{
            height:26px;
            line-height: 26px;
            padding:0 12px;
            color:#999;
            background: #fff;
            font-size: 13px;
            margin-right: 15px;
            @media screen and (max-width: 750px){
                border-radius: 26px;
            }
            &.actived{
                background:#328DF7;
                color:#fff;
            }
        }
    }
    .record-list{
        background: #fff;
        padding:0 20px;
        margin-top: 10px;
        @media screen and (max-width: 750px){
            border-radius: 4px;
        }
        .record-item{
            padding:14px 0;
            border-bottom: 1px solid #f5f5f5;
            &:last-child{
                border:none;
            }
            .item-top{
                @include flex-between();
                line-height: 25px;
                margin-bottom: 5px;
                .item-count{
                    font-size: 18px;
                    color:#333;
                    font-weight: 400;
                    font-family: PingFangSC-Regular, PingFang SC;
                }
                .item-status{
                    font-size: 15px;
                    color:#666;
                    &.waiting{
                        color:#FFA11F;
                    }
                }
            }
            .item-bottom{
                @include flex-between();
                line-height: 18px;
                color:#999;
                font-size: 12px;
            }
            &.no-more{
                color:#999;
                font-size: 12px;
                text-align: center;
            }
        }
    }
}
</style>